// extracted by mini-css-extract-plugin
export default {"card":"discount-card_card__KGrkA","card__footer":"discount-card_card__footer__fDHAu"};